import {
  Coin,
  CoinDataOutputWrapper,
  CoinValue,
  Header,
  HeaderWrapper,
  TokenReceivedWrapper,
  TransactableCoinsWrapper,
  WrapperCoin,
} from '../styled'
import { LoaderWrapper, PriceWrapper } from '../../input-field/styled'

import { BalanceLoader } from 'components/balance-loader'
import CoinDetails from './coin-details'
import { Index } from 'hooks/type-of-use-indices'
import React from 'react'
import TokensReceivedModal from './tokens-received-modals'
import { assetsList } from 'abis/set/asset-icons'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { useTransactionalContext } from '../../transactional-context'

const MAX_COINS_TO_DISPLAY = 8

interface TokensReceivedProps {
  indexInfo: Index
}

/**
 * React component
 * Shows the user the tokens they will receive from this transaction
 */

const TokensReceived: React.FC<TokensReceivedProps> = () => {
  const {
    transactableCoins,
    receivedTokens,
    isBuying,
    loadingValues,
    inputAssetAmount,
    inputIndexAmount,
    priceImpactState,
  } = useTransactionalContext()
  const [loading, setLoading] = React.useState<boolean>(false)
  const { currentStep } = useTourGuide()
  const [amount, setAmount] = React.useState<string>('0.00')

  const getFormattedAmountInDollars = (amount: string): string => {
    if (amount && isBuying) {
      return '$1,782.44'
    } else {
      return `~$0.00`
    }
  }

  React.useEffect(() => {
    if (currentStep >= 9) {
      setAmount('15')
    } else {
      setAmount('0.00')
    }
  }, [currentStep])

  React.useEffect(() => {
    if (Number(inputAssetAmount) > 0 || Number(inputIndexAmount) > 0) {
      setLoading(true)
    }
  }, [inputAssetAmount, inputIndexAmount])

  React.useEffect(() => {
    if (!loadingValues) {
      setLoading(false)
    }
  }, [loadingValues])
  const getIcon = () => {
    if (isBuying) {
      return assetsList['0x632806bf5c8f062932dd121244c9fbe7becb8b48'].icon
    }
    return assetsList['0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2'].icon
  }
  return (
    <TokenReceivedWrapper priceImpactWarning={priceImpactState} id="tour-received-box">
      <HeaderWrapper>
        <Header>Tokens received</Header>
      </HeaderWrapper>

      {receivedTokens?.length && (
        <WrapperCoin key={`${receivedTokens[0].token}-${receivedTokens[0].outputAmount}`}>
          <Coin src={getIcon()} />
          <CoinDataOutputWrapper>
            <CoinValue>{!loading ? amount : <BalanceLoader margin={'2px 0 0 0'} />}</CoinValue>
            <PriceWrapper>
              {!loading ? (
                getFormattedAmountInDollars(amount)
              ) : (
                <LoaderWrapper>
                  {`~$`}
                  <BalanceLoader gray />
                </LoaderWrapper>
              )}
            </PriceWrapper>
          </CoinDataOutputWrapper>
        </WrapperCoin>
      )}

      <TransactableCoinsWrapper>
        {transactableCoins.map((coin) => (
          <CoinDetails key={coin.symbol} coin={coin} />
        ))}
        {transactableCoins.length > MAX_COINS_TO_DISPLAY && <TokensReceivedModal />}
      </TransactableCoinsWrapper>
    </TokenReceivedWrapper>
  )
}

export default TokensReceived
